var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCampaignMail = function SvgCampaignMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.834.334h-11a1.5 1.5 0 0 0-1.5 1.5v11a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-11a1.5 1.5 0 0 0-1.5-1.5M5.9 7.524C3.066 5.469 3.095 5.464 2.334 4.87v-.786a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 .75.75v.786c-.762.593-.732.598-3.566 2.655-.328.239-.981.816-1.434.809-.453.007-1.105-.57-1.434-.81m6.434-1.385v4.445a.75.75 0 0 1-.75.75h-8.5a.75.75 0 0 1-.75-.75V6.139c.436.338 1.042.79 2.978 2.195.443.323 1.187 1.004 2.022 1 .84.004 1.595-.689 2.022-1 1.937-1.406 2.542-1.857 2.978-2.195"
  })));
};
export default SvgCampaignMail;